import EditorViewState from 'owa-editor/lib/store/schema/EditorViewState';
import { RecipientContainer } from 'owa-link-data';
import { trace } from 'owa-trace';
import { Editor } from 'roosterjs-editor-core';
import { createLinkPlaceholder } from '../components/LinkPlaceholder';
import { OWA_INSERT_LINK_PLACEHOLDER_CLASSNAME } from './constants';
import { isInsertLinkPendingOrFailed } from './isInsertLinkPendingOrFailed';
import { LinkIdContainer } from 'owa-attachment-link-common';

export function insertLinkPlaceholdersRemoveOrRehydrate(
    editor: Editor,
    editorViewState: EditorViewState,
    getRecipientWells: () => RecipientContainer[],
    linkIdContainer: LinkIdContainer,
    fromAddress: string,
    targetWindow: Window
) {
    // If editor has been disposed, no need to continue
    if (!editor) {
        return;
    }

    const allInsertLinks: HTMLElement[] = editor.queryElements(
        '.' + OWA_INSERT_LINK_PLACEHOLDER_CLASSNAME
    );

    // Process all the insert link placeholders
    // If the view state is still in store, rehydrate it.
    // if the view state doesn't exist, remove the placeholder.
    allInsertLinks.forEach(element => {
        if (!isInsertLinkPendingOrFailed(element.id)) {
            trace.info(`Removing insert link placeholder for ${element.id}`);
            editor.deleteNode(element);
        } else {
            trace.info(`Rehydrating insert link placeholder ${element.id}`);
            createLinkPlaceholder(
                editorViewState,
                element.id,
                getRecipientWells,
                linkIdContainer,
                fromAddress,
                element,
                targetWindow,
                false /*shouldDisplayInNextLine*/
            );
        }
    });
}
